/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DocumentDetailsRequestDTO = {
    contents?: Array<string>;
    documentNumber?: string;
    documentType?: DocumentDetailsRequestDTO.documentType;
    mimeExt?: string;
};

export namespace DocumentDetailsRequestDTO {

    export enum documentType {
        CERTIFICATE_OF_REGISTRATION = 'CERTIFICATE_OF_REGISTRATION',
        APPLICATION_OF_REGISTRATION = 'APPLICATION_OF_REGISTRATION',
        BUSINESS_LICENSE = 'BUSINESS_LICENSE',
        PARTNERSHIP_DEED = 'PARTNERSHIP_DEED',
        FORM_3_4 = 'FORM_3_4',
        REGULATIONS = 'REGULATIONS',
        FORM_B = 'FORM_B',
        CERTIFICATE_OF_INCORPORATION = 'CERTIFICATE_OF_INCORPORATION',
        APPLICATION_FOR_REGISTRATION = 'APPLICATION_FOR_REGISTRATION',
        PARTNERSHIP_AGREEMENT_DEED = 'PARTNERSHIP_AGREEMENT_DEED',
        MEMAT = 'MEMAT',
        BOARD_RESOLUTION = 'BOARD_RESOLUTION',
        COPY_OF_RULES_CONSTITUTION = 'COPY_OF_RULES_CONSTITUTION',
        RESOLUTION_LETTER_SIGNED_BY_PRESIDENT = 'RESOLUTION_LETTER_SIGNED_BY_PRESIDENT',
        SCUML_CERTIFICATE = 'SCUML_CERTIFICATE',
    }


}

